import { render, staticRenderFns } from "./jev-modal.vue?vue&type=template&id=c2929c3e&scoped=true&"
import script from "./jev-modal.vue?vue&type=script&lang=js&"
export * from "./jev-modal.vue?vue&type=script&lang=js&"
import style0 from "./jev-modal.vue?vue&type=style&index=0&id=c2929c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2929c3e",
  null
  
)

export default component.exports